<div class="companies-page">
  @if (isLoading) {
    <div class="companies-page__overlay">
      <div class="companies-page__spinner" role="status">
        <span class="sr-only">{{ "MESSAGES.LOADING" | translate }}</span>
      </div>
    </div>
  }

  <div class="companies-page__title-row">
    <h6 class="companies-page__title">
      {{
        ((showCompanyHint$ | async) === false
          ? "COMPONENTS.COMPANIES.SELECT_COMPANY"
          : "COMPONENTS.COMPANIES.CREATE_COMPANY"
        ) | translate
      }}
    </h6>
  </div>

  @if ((showCompanyHint$ | async) === true) {
    <div id="new-company-hint" class="companies-page__hint">
      <div class="companies-page__hint-visual">
        @if ((theme$ | async) === "light") {
          <img src="assets/img/empty-company-list.png" alt="empty content" />
        } @else {
          <img src="assets/img/empty-company-list-dt.png" alt="empty content" />
        }

        <svg
          id="pointer"
          width="70"
          height="70"
          viewBox="0 0 120 125"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1229_2086)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.119153 25.8221C0.540799 26.8882 0.943732 27.9436 1.43455 28.9748C5.88864 38.1028 12.2732 46.2857 19.335 53.8393C27.0529 62.11 35.9602 69.4361 45.5986 75.6446C59.1027 84.3621 73.9512 91.2718 89.2367 94.9216C95.9782 96.5389 102.785 97.2547 109.511 97.6776C109.741 97.7087 109.951 97.5558 109.978 97.3118C110.009 97.0824 109.856 96.8724 109.612 96.8454C103.089 95.5618 96.6739 93.5859 90.1613 91.5424C75.5264 86.9394 60.9647 80.7231 47.7338 72.3084C38.2921 66.2977 29.4799 59.3712 21.6201 51.613C14.4067 44.4799 8.28159 36.4932 2.67003 28.2538C2.03027 27.3113 1.3335 26.4476 0.693742 25.5051C0.601083 25.3415 0.411549 25.2836 0.247958 25.3763C0.0843737 25.469 0.0264943 25.6585 0.119153 25.8221Z"
              fill="#3E3A3A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M109.602 96.864C104.426 98.677 97.4124 100.573 95.4659 101.176L88.4749 103.382C85.8952 104.318 83.8866 105.379 84.7816 106.787C85.2239 108.668 88.6355 107.091 89.5614 106.961L96.6205 105.115C98.9096 104.496 110.406 101.531 115.012 99.9385C117.417 99.1141 118.4 97.5957 118.484 97.2727C118.649 96.5015 118.484 95.2224 117.133 94.1615C115.5 92.8791 110.406 90.9471 109.787 90.6457C106.271 89.0018 102.891 87.1627 99.5146 85.3383C94.3734 82.5519 89.3161 79.7266 84.3679 76.5555C83.9507 76.2453 83.3592 76.3304 83.0489 76.7476C82.7387 77.1648 82.8238 77.7563 83.241 78.0665C86.2392 80.6897 89.196 83.2771 92.3905 85.6409C97.1855 89.1698 102.318 92.2108 107.587 95.0566C107.859 95.1861 108.845 96.1272 109.643 96.8998L109.602 96.864Z"
              fill="#3E3A3A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1229_2086">
              <rect
                width="102.657"
                height="95.2703"
                fill="white"
                transform="translate(91.8086) rotate(74.5092)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div id="hint-text" class="companies-page__hint-copy">
        <p class="companies-page__hint-title">
          {{ "COMPONENTS.COMPANIES.EMPTY_LIST" | translate }}
        </p>
        <p class="companies-page__hint-description">
          {{ "TOOLTIPS.EMPTY_COMPANY_LIST" | translate }}
        </p>
      </div>
    </div>

    <div class="companies-page__empty-add-row">
      <div
        class="card add-button companies-page__empty-add-button"
        role="button"
        tabindex="0"
        (click)="createCompany()"
        (keydown.enter)="createCompany()"
      >
        <div class="ellipse">
          <svg
            width="25"
            height="25"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.583 21.9167H28.083V3.41666C28.083 2.59891 27.7582 1.81465 27.1799 1.23642C26.6017 0.658179 25.8174 0.333328 24.9997 0.333328C24.1819 0.333328 23.3977 0.658179 22.8194 1.23642C22.2412 1.81465 21.9163 2.59891 21.9163 3.41666V21.9167H3.41634C2.59859 21.9167 1.81433 22.2415 1.2361 22.8197C0.657859 23.398 0.333008 24.1822 0.333008 25C0.333008 25.8177 0.657859 26.602 1.2361 27.1802C1.81433 27.7585 2.59859 28.0833 3.41634 28.0833H21.9163V46.5833C21.9163 47.4011 22.2412 48.1853 22.8194 48.7636C23.3977 49.3418 24.1819 49.6667 24.9997 49.6667C25.8174 49.6667 26.6017 49.3418 27.1799 48.7636C27.7582 48.1853 28.083 47.4011 28.083 46.5833V28.0833H46.583C47.4008 28.0833 48.185 27.7585 48.7633 27.1802C49.3415 26.602 49.6663 25.8177 49.6663 25C49.6663 24.1822 49.3415 23.398 48.7633 22.8197C48.185 22.2415 47.4008 21.9167 46.583 21.9167Z"
              fill="white"
            />
          </svg>
        </div>
        <span class="add-button__label">
          {{ "COMPONENTS.COMPANIES.CREATE_COMPANY" | translate }}
        </span>
      </div>
    </div>
  } @else {
    <div class="company-list">
      @if (allSlides$ | async; as slides) {
        <app-splide-slider
          #spliderRef
          [itemsCount]="slides.companies.length + slides.invites.length + 1"
        >
          @for (invite of slides.invites; track invite.id) {
            <li class="splide__slide">
              <div class="card invite-card">
                @if (invite.imageUrl !== notFound) {
                  <img
                    class="company-img"
                    [src]="invite.imageUrl"
                    alt="company image"
                  />
                } @else {
                  <div class="company-img no-image">
                    {{ invite.companyName | abbreviation }}
                  </div>
                }

                <p class="company-title" title="{{ invite.companyName }}">
                  {{ invite.companyName }}
                </p>

                <hr />

                <p class="invite-card__description">
                  {{ "MESSAGES.USER_INVITE" | translate }}
                  <b>{{ invite.senderFullName }}</b>
                </p>

                <div class="invite-card__actions">
                  <button
                    type="button"
                    class="button btn-red invite-card__button"
                    (click)="rejectInvite(invite.id)"
                  >
                    {{ "BUTTONS.REJECT" | translate }}
                  </button>

                  <button
                    type="button"
                    class="button btn-green invite-card__button"
                    (click)="acceptInvite(invite.id)"
                  >
                    {{ "BUTTONS.ACCEPT" | translate }}
                  </button>
                </div>
              </div>
            </li>
          }

          @for (company of slides.companies; track company.id) {
            <li class="splide__slide">
              <div
                class="card company-card"
                role="button"
                tabindex="0"
                (click)="openCompany(company)"
                (keydown.enter)="openCompany(company)"
              >
                @if (company.imageUrl !== notFound) {
                  <img
                    class="company-img"
                    [src]="company.imageUrl"
                    alt="company image"
                  />
                } @else {
                  <div class="company-img no-image">
                    {{ company.name | abbreviation }}
                  </div>
                }
                <p class="company-title company-title--company" title="{{ company.name }}">
                  {{ company.name }}
                </p>
                <p class="company-description" title="{{ company.description }}">
                  {{ company.description }}
                </p>
              </div>
            </li>
          }

          <li class="splide__slide">
            <div
              class="card add-button add-button--slide"
              role="button"
              tabindex="0"
              (click)="createCompany()"
              (keydown)="createCompany()"
            >
              <div class="ellipse">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M46.583 21.9167H28.083V3.41666C28.083 2.59891 27.7582 1.81465 27.1799 1.23642C26.6017 0.658179 25.8174 0.333328 24.9997 0.333328C24.1819 0.333328 23.3977 0.658179 22.8194 1.23642C22.2412 1.81465 21.9163 2.59891 21.9163 3.41666V21.9167H3.41634C2.59859 21.9167 1.81433 22.2415 1.2361 22.8197C0.657859 23.398 0.333008 24.1822 0.333008 25C0.333008 25.8177 0.657859 26.602 1.2361 27.1802C1.81433 27.7585 2.59859 28.0833 3.41634 28.0833H21.9163V46.5833C21.9163 47.4011 22.2412 48.1853 22.8194 48.7636C23.3977 49.3418 24.1819 49.6667 24.9997 49.6667C25.8174 49.6667 26.6017 49.3418 27.1799 48.7636C27.7582 48.1853 28.083 47.4011 28.083 46.5833V28.0833H46.583C47.4008 28.0833 48.185 27.7585 48.7633 27.1802C49.3415 26.602 49.6663 25.8177 49.6663 25C49.6663 24.1822 49.3415 23.398 48.7633 22.8197C48.185 22.2415 47.4008 21.9167 46.583 21.9167Z"
                    fill="white"
                  />
                </svg>
              </div>
              <span class="add-button__label">
                {{ "COMPONENTS.COMPANIES.CREATE_COMPANY" | translate }}
              </span>
            </div>
          </li>
        </app-splide-slider>
      }
    </div>
  }
</div>
